import {observer} from 'mobx-react';
import React from 'react';
import {PromiseMessage} from '../../../../lib/components';
import {X4UnitStore} from '../X4UnitStore';

@observer
export class EditLessonControls extends React.Component<{ store: X4UnitStore }> {
  render() {
    const {store} = this.props;

    if (store.editLesson === null)
      return null;

    const editLesson = store.editLesson;
    const isPending = editLesson.save?.isPending === true;

    return (<>
      <div className="row justify-content-end">
        <div className="col-auto">
          <button type="button" className="btn btn-primary"
                  onClick={store.completeEdit}
                  disabled={isPending}>
            Save
          </button>
          <button type="button" className="btn btn-primary"
                  onClick={store.cancel}
                  disabled={isPending}>
            Cancel
          </button>
        </div>
      </div>

      <PromiseMessage label="Saving" state={editLesson.save} align="right"/>
    </>);
  }
}
